import { ClientDataService, IClientDataDoc } from '../../../../services/clientData.service'

export class ImagingUltrasoundService extends ClientDataService {
  private IMAGE_ULTRA_LOCATION_DOC = 'v_primageultraloc'
  private TYPE_DOC = 'v_primageultratype'
  private IMAGE_ULTRA_FINDINGS = 'v_primageultrafind'

  async getImagingLocationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IMAGE_ULTRA_LOCATION_DOC)
  }

  async getTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TYPE_DOC)
  }

  async getImagingFindingsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IMAGE_ULTRA_FINDINGS)
  }
}
